import "../scss/Home.scss"

import { useState } from "react";
import HandleToggle from "../components/HandleToggle";

import db from "../modules/firebaseMod.js";
import { collection, addDoc } from "firebase/firestore";

const TitleDefault = "Awesome Name"
const DescriptionDefault = "Awesome Description"

const handles = [
    "Facebook", 
    "Instagram", 
    "Twitter", 
    "Github", 
    "TikTok", 
    "Snapchat", 
    "Pinterest", 
    "Reddit", 
    "YouTube", 
    "WhatsApp",
    "Twitch"
]

function Home() {
    const [link, setLink] = useState("")
    const [cooldown, setCoolDown] = useState(false)

    return <div>

        <div className="Title">Linked Letter</div>
        <div id="info-header">Click on each social media that you have then enter your link for that social media</div>
        <div className="handle-list-label">Links</div>
        <div id="handle-checklist">
            {handles.map((value, index) => {
                return <HandleToggle name={value} key={index}/>
            })}
        </div>
        <div id="basic-info-box">
            <div className="letter-input-label">Name:</div>
            <input id="letter-title-input" placeholder={TitleDefault}></input>
            <div className="letter-input-label">About Me:</div>
            <textarea id="letter-description-input" placeholder={DescriptionDefault}></textarea>

            <div id="create-letter-button" onClick={() => {
                if (cooldown) {return}

                try {
                    setCoolDown(true)

                    let name = document.getElementById("letter-title-input").value
                    if (name == "")
                        name = TitleDefault

                    // Getting all the handles
                    let handleLinks = {}
                    handles.map((value) => {
                        const handleValue = document.getElementById("Handle-Input-"+value).value
                        if (handleValue != "")
                        {
                            handleLinks[value] = handleValue
                            console.log("handles")
                        }
                    })

                    const prom = addDoc(collection(db, "letters"), {
                        name: name,
                        description: document.getElementById("letter-description-input").value,
                        handles: handleLinks
                    });

                    const createButton = document.getElementById("create-letter-button")
                    createButton.classList.add("waiting-for-link")
                    prom.then((docRef) => {
                        // window.location.href = window.location.href+"Letter?letter="+docRef.id
                        setLink(window.location.href+"Letter?letter="+docRef.id)
                        document.getElementById("link-display").dataset.hasList="true"

                        createButton.classList.remove("waiting-for-link")
                        createButton.classList.add("spin-anim")
                        setTimeout(() => {
                            createButton.classList.remove("spin-anim")
                            setCoolDown(false)
                        }, 1000)
                    })
                } catch (e) {
                    console.error("Error adding document: ", e);
                }
            }}>Write</div>
        </div>
        <div href={link} id="link-display" onClick={() => {window.location.href=link}}>{link || "test"}</div>
        <div id="link-label">Link</div>
        {/* <button id="enter-button">Enter</button> */}
        
    </div>
}

export default Home